import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import MicrosoftCosmosDbReaderForm from '../forms/microsoft-cosmos-db-reader-form';
import { microsoftCosmosDbReaderValidationSchema } from '../schema/microsoftCosmosDbReader.js';

export default function MicrosoftCosmosDbReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Microsoft Cosmos DB Reader Node Details',
        altText: 'Microsoft Cosmos DB Reader Node',
        defaultLabel: 'Microsoft Cosmos DB Reader Node',
      }}
    >
      <CommonNode
        FormComponent={MicrosoftCosmosDbReaderForm}
        schemaResolver={microsoftCosmosDbReaderValidationSchema}
      />
    </NodeProvider>
  );
}
